import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import createaction from "../../context/action/mizania/createaction";
import Mizanialist from "./mizanialist";

const Mizania = () => {
    const { recaller, setrecaller, initDispatch, clear } = useContext(GlobalContext);

    const [mizania_statement_number, setmizania_statement_number] = useState('');
    const [mizania_directory_number, setmizania_directory_number] = useState('');
    const [mizania_name, setmizania_name] = useState('');
    const [mizania_amount, setmizania_amount] = useState(0);
    const [mizania_date, setmizania_date] = useState('');
    const [mizania_type, setmizania_type] = useState('general_budget');
    const [mizania_category, setmizania_category] = useState(0);

    const [error, seterror] = useState(false);
    const [error1, seterror1] = useState(false);
    const [error2, seterror2] = useState(false);
    const [error3, seterror3] = useState(false);

    return (
        <div className="min-h-screen bg-slate-50 p-6 md:p-8">
            {/* Page Header */}
            <div className="flex items-center justify-between mb-8">
                <div>
                <h1 className="text-2xl font-bold text-slate-800">میزانییە</h1>
                <p className="text-sm text-slate-400 mt-0.5">بەڕێوەبردنی میزانییە</p>
                </div>
            </div>
            <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
                  <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-4 gap-4 items-end">
                    <div className="w-full">
                      <label
                        className={
                          "block text-sm font-medium text-slate-500 mb-1 text-right"
                        }
                        htmlFor="mizania_statement_number"
                      >
                        رقم الكشف
                      </label>
                      <input
                        className={
                          "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        }
                        id="mizania_statement_number"
                        type="text"
                        placeholder=""
                        onClick={(val)=>{val.target.select()}}
                        value={mizania_statement_number}
                        onChange={(val) => setmizania_statement_number(val.target.value)}
                      />
                    </div>
                    <div className="w-full">
                      <label
                        className={
                          "block text-sm font-medium text-slate-500 mb-1 text-right"
                        }
                        htmlFor="mizania_directory_number"
                      >
                        رقم الدليل
                      </label>
                      <input
                        className={
                          "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        }
                        id="mizania_directory_number"
                        type="text"
                        placeholder=""
                        onClick={(val)=>{val.target.select()}}
                        value={mizania_directory_number}
                        onChange={(val) => setmizania_directory_number(val.target.value)}
                      />
                    </div>
                    <div className="w-full">
                      <label
                        className={
                          error
                            ? "block text-sm font-medium text-red-500 mb-1 text-right"
                            : "block text-sm font-medium text-slate-500 mb-1 text-right"
                        }
                        htmlFor="mizania_name"
                      >
                        ناو
                      </label>
                      <input
                        className={
                          error
                            ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                            : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        }
                        id="mizania_name"
                        type="text"
                        placeholder=""
                        onClick={(val)=>{val.target.select()}}
                        value={mizania_name}
                        onChange={(val) => setmizania_name(val.target.value)}
                        onFocus={() => seterror(false)}
                      />
                    </div>
                    <div className="w-full">
                      <label
                        className={
                          error1
                            ? "block text-sm font-medium text-red-500 mb-1 text-right"
                            : "block text-sm font-medium text-slate-500 mb-1 text-right"
                        }
                        htmlFor="mizania_amount"
                      >
                        بڕ
                      </label>
                      <input
                        className={
                          error1
                            ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                            : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        }
                        id="mizania_amount"
                        type="text"
                        placeholder=""
                        onClick={(val)=>{val.target.select()}}
                        value={mizania_amount}
                        onChange={(val) => setmizania_amount(val.target.value)}
                        onFocus={() => seterror1(false)}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 mt-2 sm:grid-cols-1 lg:grid-cols-4 gap-4 items-end">
                    <div className="w-full">
                        <label
                            className={
                            error2
                                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                                : "block text-sm font-medium text-slate-500 mb-1 text-right"
                            }
                            htmlFor="mizania_date"
                        >
                            ساڵ
                        </label>
                        <select
                            className={
                            error2
                                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            id="mizania_date"
                            value={mizania_date}
                            onChange={(val) => setmizania_date(val.target.value)}
                            onFocus={() => seterror2(false)}
                        >
                            <option value="" disabled>--</option>
                            {Array.from({ length: 15 }, (_, i) => new Date().getFullYear() - i).map((y) => (
                            <option key={y} value={y}>{y}</option>
                            ))}
                        </select>
                    </div>
                    <div className="w-full">
                        <label
                            className={
                              "block text-sm font-medium text-slate-500 mb-1 text-right"
                            }
                            htmlFor="mizania_type"
                        >
                            جۆر
                        </label>
                        <select
                            className={
                              "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            id="mizania_type"
                            value={mizania_type}
                            onChange={(val) => {
                              setmizania_type(val.target.value);
                              setmizania_category(0);
                            }}
                        >
                            <option value="general_budget">الميزانية العامة</option>
                            <option value="statement_of_current">كشف العمليات الجارية</option>
                        </select>
                    </div>
                    <div className="w-full">
                        <label
                            className={
                              error3
                                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                                : "block text-sm font-medium text-slate-500 mb-1 text-right"
                            }
                            htmlFor="mizania_category"
                        >
                            کاتیگۆری
                        </label>
                        <select
                            className={
                              error3
                                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                                : mizania_category==0
                                ? "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            id="mizania_category"
                            value={mizania_category}
                            onChange={(val) => setmizania_category(val.target.value)}
                            onFocus={() => seterror3(false)}
                        >
                            <option value={0} disabled className="text-slate-500">
                                ----- کاتیگۆری هەڵبژێرە -----
                            </option>
                          {mizania_type=="general_budget"&&
                            <>
                              <option value="الموجودات" className="text-slate-800">
                                الموجودات
                              </option>
                              <option value="الموجودات الثابتة" className="text-slate-800">
                                الموجودات الثابتة
                              </option>
                              <option value="الموجودات المتداولة" className="text-slate-800">
                                الموجودات المتداولة
                              </option>
                              <option value="مصادر التمويل" className="text-slate-800">
                                مصادر التمويل
                              </option>
                              <option value="المطلوبات المتداولة" className="text-slate-800">
                                المطلوبات المتداولة
                              </option>
                            </>}
                          {mizania_type=="statement_of_current"&&
                            <>
                              <option value="المصروفات الجارية" className="text-slate-800">
                                المصروفات الجارية
                              </option>
                              <option value="تضاف :الايرادات التحويلية الاخرى" className="text-slate-800">
                                تضاف :الايرادات التحويلية الاخرى
                              </option>
                              <option value="تنزل ـ المصروفات التحويلية الاخرى" className="text-slate-800">
                                تنزل ـ المصروفات التحويلية الاخرى
                              </option>
                            </>}
                        </select>
                    </div>
                    <div className="w-full">
                      <button
                        className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
                        onClick={() => {
                          if (mizania_name.trim() == "" || !mizania_name) {
                            seterror(true);
                            return false;
                          }
                          if (mizania_amount<0) {
                            seterror1(true);
                            return false;
                          }
                          if (mizania_date.trim() == "" || !mizania_date) {
                            seterror2(true);
                            return false;
                          }
                          if (mizania_category==0||mizania_category=="") {
                            seterror3(true);
                            return false;
                          }
                          createaction(mizania_statement_number, mizania_directory_number, mizania_name, mizania_amount, mizania_date, mizania_type, mizania_category)(recaller)(setrecaller)(initDispatch)(
                            clear
                          );
                        }}
                      >
                        زیادکردن
                      </button>
                    </div>
                  </div>
                </div>          
            <Mizanialist />
        </div>
    )
}

export default Mizania